// Note: The first file of a module here, must also register the module

import "./filter-pane.component";
import "./user-filter-pane";
import "./view-filter-dialog.component";
